import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class FloorPlansApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "floor_plans/";
	}

	updatePointFloorPlanLocations(updates, onSuccess, onError) {
		Promise.all(
			updates.map((item) =>
				fetch(item.id + "update_floor_plan_x_y/", {
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: this.getToken(),
					},
					body: JSON.stringify({
						x: item.x,
						y: item.y,
					}),
				})
			)
		)
			.then((responses) => {
				if (responses.every((r) => r.ok)) {
					onSuccess();
				} else {
					onError();
				}
			})
			.catch(() => {
				onError();
			});
	}

    async updateImage(floorPlanUrl, imageFile, onSuccess, onError) {

        const formData = new FormData();
        formData.append("image", imageFile);

        const response = await fetch(floorPlanUrl, {
                method: "PATCH",
                body: formData,
                headers: {
                    Authorization: this.getToken(),
                }
            }
        )

        if (response.ok) {
            const data = await response.json()
            onSuccess(data)
        } else {
            const data = await response.text();
            onError(data);
        }

    }

    async createNew(facility, name, imageFile, onSuccess, onError) {

        const formData = new FormData();
        formData.append("image", imageFile);
        formData.append("name", name);
        formData.append("facility", facility);

        const response = await fetch(this.baseUrl, {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: this.getToken(),
                }
            }
        )

        if (response.ok) {
            const data = await response.json()
            onSuccess(data)
        } else {
            const data = await response.text();
            onError(data);
        }

    }
}
